import AccountBalanceIcon from "@mui/icons-material/AccountBalance"; // Finance
import ApartmentIcon from "@mui/icons-material/Apartment"; // Facility
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter"; // CEO
import CampaignIcon from "@mui/icons-material/Campaign"; // Marketing
import PersonIcon from "@mui/icons-material/Person"; // Owner
import RecyclingIcon from "@mui/icons-material/Recycling";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart"; // PurchaseManager
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount"; // Chairman
import { Tooltip } from "@mui/material";
import { ContactPersonRolesEnum, ContactPersonRolesEnumLabel } from "../../../store/types/communication.types";


interface RoleIconsProps {
  role: ContactPersonRolesEnum;
}

const RoleIcon = ({ role }: RoleIconsProps) => {
  const iconProps = {
    sx: {
      fontSize: 16,
      color: "text.secondary",
      opacity: 0.7,
    },
  };

  switch (role) {
    case ContactPersonRolesEnum.CEO:
      return (
        <Tooltip title={ContactPersonRolesEnumLabel[role]}>
          <BusinessCenterIcon {...iconProps} />
        </Tooltip>
      );
    case ContactPersonRolesEnum.Finance:
      return (
        <Tooltip title={ContactPersonRolesEnumLabel[role]}>
          <AccountBalanceIcon {...iconProps} />
        </Tooltip>
      );
    case ContactPersonRolesEnum.Chairman:
      return (
        <Tooltip title={ContactPersonRolesEnumLabel[role]}>
          <SupervisorAccountIcon {...iconProps} />
        </Tooltip>
      );
    case ContactPersonRolesEnum.PurchaseManager:
      return (
        <Tooltip title={ContactPersonRolesEnumLabel[role]}>
          <ShoppingCartIcon {...iconProps} />
        </Tooltip>
      );
    case ContactPersonRolesEnum.Environment:
      return (
        <Tooltip title={ContactPersonRolesEnumLabel[role]}>
          <RecyclingIcon {...iconProps} />
        </Tooltip>
      );
    case ContactPersonRolesEnum.Marketing:
      return (
        <Tooltip title={ContactPersonRolesEnumLabel[role]}>
          <CampaignIcon {...iconProps} />
        </Tooltip>
      );
    case ContactPersonRolesEnum.Facility:
      return (
        <Tooltip title={ContactPersonRolesEnumLabel[role]}>
          <ApartmentIcon {...iconProps} />
        </Tooltip>
      );
    case ContactPersonRolesEnum.Owner:
      return (
        <Tooltip title={ContactPersonRolesEnumLabel[role]}>
          <PersonIcon {...iconProps} />
        </Tooltip>
      );
    default:
      return null;
  }
};
export default RoleIcon;
